/* eslint-disable jsx-a11y/no-onchange */
/* eslint-disable react/display-name */
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useStoreState, useStoreActions } from 'easy-peasy'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import { DateUtils } from 'react-day-picker'
// import 'react-day-picker/lib/style.css'

import dateFnsFormat from 'date-fns/format'
import dateFnsParse from 'date-fns/parse'
import dateFnsIsValid from 'date-fns/isValid'
import Text from '../../utils/Text'
import ErrorMessage from './ErrorMessage'

function parseDate(str, format, locale) {
  const parsed = dateFnsParse(str, format, new Date(), { locale })
  if (DateUtils.isDate(parsed)) {
    return parsed
  }
  return undefined
}

function formatDate(date, format, locale) {
  return dateFnsFormat(date, format, { locale })
}

function dateIsValid(date) {
  return dateFnsIsValid(date)
}

const Container = styled.div`
  /* margin: 21px auto 25px; */
  margin: 44px auto 20px;
`

const Wrapper = styled.div`
  max-width: 443px;
  margin: 0 auto;
  position: relative;
  width: 100%;
  color: #818181;
  .date-picker {
    position: absolute;
    top: 14px;
    right: 0;
    input {
      background-image: url(https://cdn1.iconfinder.com/data/icons/feather-2/24/calendar-512.png);
      background-position: 97% 7%;
      background-repeat: no-repeat;
      background-size: 17px;
      width: 436px;
      padding-bottom: 14px;

      border: none;
      &:focus {
        outline: none;
      }
      @media (max-width: 510px) {
        max-width: calc(${props => props.windowWidth}px - 70px);
      }
    }
    .DayPicker-Day--today {
      color: #414141;
      font-weight: 700;
    }
    .DayPicker-Weekday abbr[title] {
      display: none;
    }
    .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
      background-color: #414141;
      color: #f0f8ff;
    }
  }
`

const Input = styled.input`
  position: relative;
  border-radius: 0;
  font-size: 16px !important;
  width: 100%;
  height: 49px;
  border: none;
  border-bottom: 1px solid #818181 !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  padding-left: 10px;
  padding-right: 10px;
  color: transparent;
  &:focus {
    border-bottom: 1px solid #414141 !important;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    outline: none;
    box-shadow: none;
  }
`

const Title = styled.div`
  max-width: 443px;
  margin: 0 auto;
  text-align: left;
  padding-bottom: 20px;
  p {
    font-size: 18px;
    line-height: 1.61;
  }
`

const Caption = styled.div`
  user-select: none;
`

const currentYear = new Date().getFullYear()
const fromMonth = new Date(currentYear, 0)
const toMonth = new Date(currentYear - 90, 0)

const YearMonthForm = ({ date, localeUtils, onChange }) => {
  const months = localeUtils.getMonths()

  const years = []
  for (
    let i = fromMonth.getFullYear();
    i >= toMonth.getFullYear();
    i -= 1
  ) {
    years.push(i)
  }

  const handleChange = function handleChange(e) {
    const { year, month } = e.target.form
    onChange(new Date(year.value, month.value))
  }

  return (
    <Caption className="DayPicker-Caption">
      <select
        name="month"
        onChange={handleChange}
        value={date.getMonth()}
      >
        {months.map((month, i) => (
          <option key={month} value={i}>
            {month}
          </option>
        ))}
      </select>
      <select
        name="year"
        onChange={handleChange}
        value={date.getFullYear()}
      >
        {years.map(year => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </Caption>
  )
}

export default function InputText({ name, error }) {
  const [{ title }] = useStoreState(state => [
    state.form.getByName(name),
    state.form.getErrorByName(name),
  ])

  const [setInputValue] = useStoreActions(actions => [
    actions.form.setInputValue,
  ])

  const [value, setValue] = useState('')
  const [month, setMonth] = useState('')
  const [errorFormat, setErrorFormat] = useState('')
  const [windowWidth, setWindowWidth] = useState(window.inninnerWidth)

  const updateWidth = () => {
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    updateWidth()
  }, [])

  useEffect(() => {
    window.addEventListener('resize', updateWidth)
    return () => window.removeEventListener('resize', updateWidth)
  }, [windowWidth])

  return (
    <Container className="col">
      <Title>
        <Text id={title} />
      </Title>
      <Wrapper
        windowWidth={windowWidth}
        onBlur={() => {
          if (value.length > 0 || value === 'Month/Day/Year') {
            setInputValue({ name, value })
          }
        }}
      >
        <Input
          id={`text-${name}`}
          name={name}
          value={value}
          onChange={({ target: { value: val } }) => {
            setValue(val)
          }}
        />
        <div className="date-picker">
          <DayPickerInput
            formatDate={formatDate}
            format="MM/dd/yyyy"
            placeholder="Month/Day/Year"
            parseDate={parseDate}
            keepFocus={false}
            dayPickerProps={{
              month,
              modifiers: {
                disabled: [
                  {
                    after: new Date(),
                  },
                ],
              },
              captionElement: ({ date, localeUtils }) => (
                <YearMonthForm
                  date={date}
                  localeUtils={localeUtils}
                  onChange={monthDate => {
                    setMonth(monthDate)
                  }}
                />
              ),
            }}
            inputProps={{ maxLength: 10 }}
            onDayChange={date => {
              if (dateIsValid(date)) {
                setValue(`${dateFnsFormat(date, 'MM/dd/yyyy')}`)
                setMonth(date)
                setErrorFormat('')
              } else {
                setValue('')
                setErrorFormat([error])
              }
            }}
          />
        </div>
        <ErrorMessage
          error={errorFormat}
          id={`error-${name}`}
          className="error"
        />
      </Wrapper>
    </Container>
  )
}
